import * as React from 'react'
import { ServiceLocationsPropertyListProps } from './typings'
import { ServiceLocationsPropertyCard } from '.'

export const ServiceLocationsPropertyList: React.FC<
  ServiceLocationsPropertyListProps
> = (props) => {
  const { field } = props

  return (
    <>
      {props.currentPage.map((l) => (
        <ServiceLocationsPropertyCard location={l} key={l.id} field={field!} />
      ))}
    </>
  )
}
ServiceLocationsPropertyList.displayName = 'ServiceLocationsPropertyList'
